import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Loading from '../../../../components/Loading';
import Button from '../../../../components/Button';
import Table from '../../../../components/Table/Table';
import Templates from '../../hooks';
import t from '../../../../lib/translate';
import { useNavigate } from "react-router-dom";
var TemplateVersionHistory = function () {
    var _a = Templates.useContainer(), templates = _a.templates, templateKey = _a.templateKey;
    var navigate = useNavigate();
    var columns = useMemo(function () { return [
        {
            Header: t('templates.versions.version'),
            accessor: 'version'
        },
        {
            Header: t('templates.versions.content'),
            id: 'recipient',
            accessor: function (template) { return template.content.body; }
        },
        {
            Header: '',
            id: 'product.key',
            accessor: function (template) {
                return _jsx(Button, { onClick: function () { return navigate("/admin/templates/".concat(template.ownerparty.key, "/").concat(template.key, "/").concat(template.version.replace('.', '_'))); }, text: t('general.edit') });
            }
        }
    ]; }, [history]);
    if (!templates)
        return _jsx(Loading, {});
    return (_jsxs("div", { children: [_jsx("h2", { children: t('templates.versions.history', templateKey) }), _jsx(Table, { columns: columns, data: templates, pagination: true })] }));
};
export default TemplateVersionHistory;
